import React, { FC, useState } from 'react';

// eslint-disable-next-line max-len
import ErrorBudgetGraph from '@/components/composed/new-slo-views/expanded/graph/error-budget-graph';
import {
  mapToDataPointEventTotals,
  populateDailyDataTotals,
} from '@/components/composed/new-slo-views/common/utils';
import { SLOGraph } from '@/controllers';
import GraphTabs from '@/components/composed/new-slo-views/expanded/graph/graph-tabs';

import FaultZone from './fault-zone';
import { GraphState } from './types';

const LargeGraph: FC<SLOGraph & { onEdit: () => void }> = ({
  error,
  warnings,
  errorBudgetDomain,
  dataPoints,
  errorBudgetDataPoints,
  onEdit,
  publicId,
  isResponsive,
  performance,
}) => {
  const [graphState, setToggleState] = useState<GraphState>(GraphState.ShowErrorBudgetGraph);

  if (error && !(warnings.length > 0)) {
    return (
      <FaultZone
        performance={performance}
        error={error}
        warnings={warnings}
        onSloEdit={onEdit}
        publicId={publicId!}
      />
    );
  }

  return (
    <>
      {warnings.length > 0 && <GraphTabs setToggleState={setToggleState} graphState={graphState} />}

      {graphState === GraphState.ShowWarnings ? (
        error &&
        warnings.length > 0 && (
          <FaultZone
            performance={performance}
            error={error}
            warnings={warnings}
            onSloEdit={onEdit}
            publicId={publicId!}
          />
        )
      ) : (
        <ErrorBudgetGraph
          data={mapToDataPointEventTotals(dataPoints)}
          errorBudgetData={populateDailyDataTotals(errorBudgetDataPoints, dataPoints)}
          errorBudgetDataDomain={errorBudgetDomain}
          showClickPrompt={false}
          preview
          isResponsive={isResponsive}
        />
      )}
    </>
  );
};

export default React.memo(LargeGraph);
